export default __webpack_public_path__ + "static/media/Outcast Mage's Cache.81b1b570.jpg";